export class Plan {

  public amount: number;
  public created: Date;
  public currency: string;
  public id: string;
  public interval: string;
  public intervalCount: number;
  public livemode: boolean;
  public metadata: Object;
  public name: string;
  public statementDescriptor: string;
  public trialPeriodDays: number;

  constructor(json: any) {
    // data saved in dynamo
    this.amount = json.amount || 0;
    this.id = json.id || '';
    this.interval = json.interval || 0;
    this.name = json.name || '';
    this.trialPeriodDays = json.trial_period_days || 0;

    // data from stripe
    try {
      this.created = new Date(json.created);
      this.currency = json.currency;
      this.intervalCount = json.interval_count;
      this.livemode = json.livemode;
      this.metadata = json.metadata;
      this.statementDescriptor = json.statement_descriptor;
    } catch (ex) {
      this.created = null;
      this.currency = '';
      this.intervalCount = 0;
      this.livemode = false;
      this.metadata = {};
      this.statementDescriptor = '';
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/plan.ts